<template>
  <div>
  </div>
</template>

<script>
import { BufferGeometry, CircleBufferGeometry, Color, DynamicDrawUsage, InstancedBufferAttribute, InstancedBufferGeometry, InstancedMesh, Object3D, ShaderMaterial, Vector4 } from 'three'
// import { loadTexture } from '../../Core/loadTexture'
// import { loadGLTF } from '../../Core/loadGLTF'
// import { Color, Group, MeshMatcapMaterial, MeshStandardMaterial } from 'three'
import O3DNode from '../../Core/O3DNode'
import { loadTexture } from '../../Core/loadTexture'

export class ScreenSpriteMaterial extends ShaderMaterial {
  constructor () {
    super({
      vertexColors: true,
      // blending: AdditiveBlending,
      depthTest: false,
      transparent: true,
      defines: {
        USE_SIZEATTENUATION: 'true'
      },
      vertexShader: `
        #include <common>
        uniform float time;
        varying vec2 vUv;
        varying vec3 vColor;
        varying float vOpacity;

        attribute vec4 meta;

        uniform float swingSpeed;
        uniform float swingFreq;

        void main (void) {
          float rotation = 0.0;
          vec3 center = vec3(0.5, 0.5, 0.5);

          float blink = meta.x;
          float offset = meta.y;
          float fall = meta.z;

          vec4 mvPosition = modelViewMatrix * instanceMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );
          vec3 scale;
          scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );
          scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );
          scale.z = length( vec3( modelMatrix[ 2 ].x, modelMatrix[ 2 ].y, modelMatrix[ 2 ].z ) );

          #ifndef USE_SIZEATTENUATION
            bool isPerspective = isPerspectiveMatrix( projectionMatrix );
            if ( isPerspective ) scale *= - mvPosition.z;
          #endif

          vec3 alignedPosition = (position.xyz - ( center - vec3( 0.5 ) )) * scale;
          // vec2 rotatedPosition;
          // rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
          // rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
          // mvPosition.xy += rotatedPosition;
          // mvPosition.xy += rotatedPosition;
          mvPosition.xyz += alignedPosition.xyz;

          mvPosition.y += fall;
          mvPosition.x += sin((offset + time * (0.03 + swingFreq)) * 3.14159265 * 2.0) * (2.0 + swingSpeed);

          gl_Position = projectionMatrix * mvPosition;


          float myFog = max(min((30.0 - gl_Position.z) / 30.0, 1.0), 0.0);
          vOpacity = mod(blink + offset, 1.0) * myFog;

          if (gl_Position.z < 0.1) {
            vOpacity = 0.0;
          }

          vUv = uv;
          vColor = color;
        }
      `,
      fragmentShader: `
        uniform sampler2D dotTex;
        varying vec2 vUv;
        varying vec3 vColor;
        varying float vOpacity;

        void main (void) {
          vec4 dotColor = texture2D(dotTex, vUv);
          gl_FragColor = vec4(vColor.rgb, (dotColor.a * 1.5) * vOpacity);
        }
      `
    })

    this.uniforms = {
      time: { value: 0 },
      swingSpeed: { value: 0 },
      swingFreq: { value: 0 },
      dotTex: { value: null }
    }
  }
  set time (v) {
    this.uniforms.time.value = v
  }
  get time () {
    return this.uniforms.time.value
  }

  set dotTex (v) {
    this.uniforms.dotTex.value = v
  }
  get dotTex () {
    return this.uniforms.dotTex.value
  }
}

export class SnowFlakes {
  constructor ({ colorPalette, count = 128, ctx, o3d, textureURL = require('./oval.png'), glow = false, scale = 1.0 }) {
    this.resetLimit = 20
    this.distribution = 20
    this.dotScale = 0.35
    this.groupScale = 1.0
    this.fallSpeed = 0.0

    let rr = (v = 1) => (Math.random() - 0.5) * v
    this.count = count

    let circle = new CircleBufferGeometry(3 * 0.25 * scale, 36, 36)

    let dotGeo = new InstancedBufferGeometry()
    BufferGeometry.prototype.copy.call( dotGeo, circle )
    // Assign random colors to the blossoms.
    const _colorTemp = new Color();
    const metaData = new Float32Array(this.count * 4)
    const _metaTemp = new Vector4()
    const colorData = new Float32Array(this.count * 3)
    let blossomPalette = [ 0xffffff ]
    if (colorPalette) {
      blossomPalette = colorPalette
    }

    for (let i = 0; i < this.count; i ++ ) {
      _colorTemp.setHex( blossomPalette[ Math.floor( Math.random() * blossomPalette.length ) ] )
      _colorTemp.toArray( colorData, i * 3)

      _metaTemp.set(
        0, // blink
        Math.random(), // offset
        0, // fall
        0
      )
      _metaTemp.toArray(metaData, i)

      // _posTemp.y += 100.0
      // _posTemp.toArray(endingPositionData, i)
    }

    dotGeo.setAttribute('color', new InstancedBufferAttribute(colorData, 3 ) )
    let metaAttrib = new InstancedBufferAttribute(metaData, 4 ).setUsage(DynamicDrawUsage)
    dotGeo.setAttribute('meta', metaAttrib )

    this.material = new ScreenSpriteMaterial()
    loadTexture(textureURL)
      .then((v) => {
        this.material.dotTex = v
      })
    ctx.onLoop(() => {
      let time = window.performance.now() * 0.001
      this.material.time = time
    })

    let dots = new InstancedMesh(dotGeo, this.material, this.count)
    this.dots = dots
    dots.instanceMatrix.setUsage(DynamicDrawUsage)
    o3d.add(dots)

    let dummy = new Object3D()

    this.randomize = () => {
      for (let i = 0; i < this.count; i++) {
        dummy.position.set(rr(this.distribution), rr(this.distribution), rr(this.distribution))
        dummy.scale.set(this.dotScale, this.dotScale, 1)
        dummy.updateMatrix()

        metaData[i * 4 + 1] = Math.random()

        dots.setMatrixAt(i, dummy.matrix)
      }
      dots.instanceMatrix.needsUpdate = true;
    }
    this.randomize()

    ctx.onLoop(() => {
      // let time = window.performance.now() * 0.001

      for (let i = 0; i < this.count; i++) {
        // dots.getMatrixAt(i, dummy.matrix)
        // dummy.position.setFromMatrixPosition(dummy.matrix)
        // dummy.updateMatrix()
        // dummy.scale.set(this.dotScale, this.dotScale, 1)
        // dots.setMatrixAt(i, dummy.matrix)

        // blink
        // metaData[i * 4 + 0] = time % 1.0

        // fall
        metaData[i * 4 + 2] -= 0.006 + this.fallSpeed / 100.0
        let fall = metaData[i * 4 + 2]
        let offset = metaData[i * 4 + 1]
        if ((fall - offset * 20.0) < -20) {
          metaData[i * 4 + 2] = 10
        }
      }
      dots.instanceMatrix.needsUpdate = true;
      dots.scale.set(this.groupScale,this.groupScale,this.groupScale)

      dots.count = this.count

      metaAttrib.needsUpdate = true
    })

    dots.userData.bloom = glow
    this.dots = dots
  }
  get glow () {
    return this.dots.userData.bloom
  }
  set glow (v) {
    this.dots.userData.bloom = v
  }
}

export default {
  mixins: [
    O3DNode
  ],
  methods: {
    async setup () {
      // let loaded = await loadGLTF(require('file-loader!./star-6.glb'))
      // let yellowMetalic = await loadTexture(require('./yellow-metalic.png'))
      // let yellow = new Color('#ffff00')
      // let group = new Group()
      // loaded.scene.traverse((item) => {
      //   if (item.isMesh) {
      //     // console.log(item.position.toArray().join(', '))
      //     item.position.z = 0
      //     item.material = new MeshStandardMaterial({ color: yellow })
      //     item.material = new MeshMatcapMaterial({ matcap: yellowMetalic })
      //     item.userData.bloom = true
      //     group.add(item)
      //   }
      // })
      // this.o3d.add(group)

      let cluster = new SnowFlakes({ count: 64, o3d: this.o3d, ctx: this.ctx, textureURL: require('./snowflake.png'), glow: true, scale: 0.5 })
      this.$emit('ready', cluster)
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>